module.exports = "assets/img/durbuy-o-signature.png";